import Vue from 'vue'
import Vuex from 'vuex'

import login from './modules/login'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

/* El state está modularizado por si habian más de un state diferente, 
pero de momento solo contempla el login, si en el futuro no hay más que el login 
se puede apañar en un simple archivo */
export default new Vuex.Store({
	plugins: [createPersistedState()],
	state: {
		adminMenu: null,
		isLoading: null
	},
	mutations: {
		adminMenu(state, payload) {
			state.adminMenu = payload
		},
		isLoading(state, payload) {
			state.isLoading = payload
		}
	},
	actions: {
		adminMenu({ commit }, payload) {
			commit('adminMenu', payload)
		},
		isLoading({ commit }, payload) {
			commit('isLoading', payload)
		}
	},
	getters: {
		adminMenu: state => {
			return state.adminMenu
		},
		isLoading: state => {
			return state.isLoading
		}
	},
	modules: {
		login
	}
})
